import httpClient from '../httpClient';

const info = async (term_id) => {
  return await httpClient.get(`/term_payments/${term_id}/info/`);
};

const post = async (data) => {
  return await httpClient.post(`/term_payments/`, data);
};

const getAll = async () => {
  return await httpClient.get(`/term_payments/`);
};

const get = async (id) => {
  return await httpClient.get(`/term_payments/${id}`);
};

const put = async (id, data) => {
  return await httpClient.put(`/term_payments/${id}/`, data);
};

const patch = async (id) => {
  return await httpClient.patch(`/term_payments/${id}`);
};

const remove = async (id) => {
  return await httpClient.delete(`/term_payments/${id}`);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'numero',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/term_payments/export${query}&sort=${sortBy}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/term_payments${query}&page[number]=${page}&page[size]=${pageSize}&sort=${sortBy}${searchBy}`,
    );
};

const productsTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'codigo',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';
  if (search) searchBy = '&filter[search]=' + search;

  const url = `/term_payment_products/?filter[termino]=${query}&page[number]=${page}&page[size]=${pageSize}&sort=${sortBy}${searchBy}`;

  if (exportCSV)
    return await httpClient.get(
      `/term_payment_products/export/?filter[termino]=${query}&sort=${sortBy}${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else return await httpClient.get(url);
};

const productsAssignTable = async (query = '', productIDs = []) => {
  return await httpClient.post(
    `term_payment_products/?filter[termino]=${query}`,
    { id_list: productIDs },
  );
};

export {
  info,
  post,
  getAll,
  get,
  put,
  patch,
  remove,
  ajaxTable,
  productsTable,
  productsAssignTable,
};
